import { h, Component } from 'preact';
import { sortObjectByOrder, joinClasses } from 'utils/utils';
import Link from 'components/bolt/link/link';
import HTML from 'components/core/html/html';
import Store from 'store/store';
import s from 'components/bolt/curzonFooter/curzonFooter.sss';
import { smoothScrollTo } from 'utils/smoothScroll';

export default class CurzonFooter extends Component {
	constructor(props) {
		super(props);

		this.renderLink = this.renderLink.bind(this);
	}

	renderNav(nav, extraNav) {
		let links = sortObjectByOrder(nav);
		links = links.concat(sortObjectByOrder(extraNav));

		return (
			<div class={joinClasses(s.nav, s.section)}>
				{links.map(link => this.renderLink(link, 'nav'))}
			</div>
		);
	}

	renderLink(element, section) {
		const page = Object.values(this.props.appData.pages).find(page => page.id === element.path)?.id;
		const isInternalLink = !!page || element.path?.startsWith('@');
		const activePage = this.props.activePage || 'boltHome';
		const active = activePage === element.path;
		const copy = this.props.appData?.copy.baseCopy;

		let attributes = {};
		const content = copy[element.name] || element.name;

		if (!isInternalLink) {
			attributes.href = element.path;
			attributes.target = element.sameWindow ? '_self' : '_blank';
			attributes.rel = 'noopener noreferrer';
			attributes.onClick = () => {
				Store.emit('CUSTOM_EVENT', {
					category: 'footer',
					action: section + '-link-click',
					label: content
				});
			};
		} else {
			attributes.onClick = element.onClick || (() => {
				Store.emit('CUSTOM_EVENT', {
					category: 'footer',
					action: section + '-link-click',
					label: content
				});
				if (Store.get().activePage === page) {
					smoothScrollTo(document.getElementById('mainScroll'), 0, 600);
				} else {
					Store.emit('CLOSE_AND_NAVIGATE', page);
				}
			});
		}

		return (
			<Link
				key={element.name}
				class={joinClasses(s.link, active && s.active)}
				ariaLabel={element.name}
				{...attributes}
			>
				<HTML class={s.content} content={content} markdown />
			</Link>
		);
	}

	renderHelp(data) {
		const links = sortObjectByOrder(data).filter(e => typeof e !== 'string');

		return (
			<div class={joinClasses(s.help, s.section)}>
				<div class={s.sectionTitle}>
					{data.title}
				</div>
				{links.map(link => this.renderLink(link, 'help'))}
			</div>
		);
	}

	renderCurzonsites(data) {
		const links = sortObjectByOrder(data).filter(e => typeof e !== 'string');

		return (
			<div class={joinClasses(s.curzonsites, s.section)}>
				<div class={s.sectionTitle}>
					{data.title}
				</div>
				{links.map(link => this.renderLink(link, 'websites'))}
			</div>
		);
	}

	renderFollow(data) {
		const socials = sortObjectByOrder(data, ((value, key) => [key, value])).filter(e => typeof e[1] !== 'string');
		const accessibilityCopy = this.props.appData?.copy.accessibilityCopy;

		return (
			<div class={s.follow}>
				<div class={s.sectionTitle}>
					{data.title}
				</div>
				<div class={s.socials}>
					{socials.map(([id, social]) => (
						<Link
							class={s.social}
							href={social.destination}
							target="_blank"
							rel="noopener noreferrer"
							ariaLabel={accessibilityCopy.$SOCIAL_ARIA.replace('<platform>', id)}
							onClick={() => Store.emit('CLICKED_FOLLOW', id)}
						>
							<img class={s.icon} src={social.icon} alt='' />
						</Link>
					))}
				</div>
			</div>
		);
	}

	renderNewsletter(data) {
		return (
			<form class={s.newsletter}>
				<div class={s.sectionTitle}>
					{data.title}
				</div>
				<input class={s.field} type="email" name="email" />
				<input class={s.submit} type="submit" value={data.signup} />
			</form>
		);
	}

	renderBafta(data) {
		const { award, category } = data;
		return (
			<div class={s.bafta}>
				<div class={s.sectionTitle}>
					{award}
				</div>
				<div class={s.category}>
					{category}
				</div>
			</div>
		);
	}

	renderLinks(data) {
		let links = sortObjectByOrder(data);

		return (
			<div class={s.links}>
				{links.map(link => this.renderLink(link, 'legal'))}
			</div>
		);
	}

	render(props) {
		const { data, appData } = props;
		const { extraNav, help, curzonsites, follow, newsletter, bafta, links } = data;
		const nav = appData?.header?.curzonHeader?.nav;

		return (
			<footer class={s.wrapper}>
				<div class={s.container}>
					<div class={s.top}>
						{this.renderNav(nav, extraNav)}
						{this.renderHelp(help)}
						{this.renderCurzonsites(curzonsites)}
						{this.renderFollow(follow)}
						{newsletter && this.renderNewsletter(newsletter)}
					</div>
					<div class={s.bottom}>
						{this.renderBafta(bafta)}
						{this.renderLinks(links)}
					</div>
				</div>
			</footer>
		);
	}
}
